export function createOAuthRedirect(params: {
  flow: "direct-to-bank" | "amend";
  result: "SUCCESS" | "CANCELLED" | "ERROR";
  redirectUriBase: string;
  state: string;
  message: string;
  sessionId?: string; // code
}) {
  const { result, redirectUriBase, state, message, sessionId } = params;

  const queryParams = new URLSearchParams({
    state,
  });

  if (result === "SUCCESS" && sessionId) {
    queryParams.append("code", sessionId);
  } else if (result === "ERROR") {
    queryParams.append("error", "access_denied");
    queryParams.append("error_description", `Error: ${message}`);
  } else if (result === "CANCELLED") {
    queryParams.append("error", "access_denied");
    queryParams.append("error_description", `Cancelled: ${message}`);
  }
  let redirectUriHasQueryString = redirectUriBase.includes("?");

  return `${redirectUriBase}${
    redirectUriHasQueryString ? "&" : "?"
  }${queryParams.toString()}`;
}
